import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { SendEmailsStore } from "../stores/sendEmailsStore";

export const useSendEmailsStore = () => useContext<{
  sendEmailsStore: SendEmailsStore
}>(StoreContext);